import React from 'react'
//CSS
import * as css from '../FondosAsignados.css'

export class RowFondosAsignados extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        return (
            <tr key={this.props.index}>
                {/* Index */}
                <td className={css.tdIndex}>{this.props.index+1}</td>
                {/* Descripcion */}
                <td className={"hidden-xs "+css.tdNSemana}>{this.props.fondo.fecha_inicial+" a "+this.props.fondo.fecha_final}</td>
                <td className={"hidden-sm hidden-md hidden-lg "+css.tdNSemana}>{this.props.fondo.numero_semana}</td>
                <td className={css.tdEstado}>{this.props.fondo.anio}</td>
                {/* Estado */}
                <td className={css.tdEstado}>{this.props.fondo.estado}</td>
                {/* Rendir */}
                <td className={css.tdRendir}>{this.props.fondo.total_girado? this.props.fondo.total_girado.toLocaleString("es-CL", {style: "currency", currency: "clp"}) : 0}</td>
                {/* TotalGasto */}
                <td className={css.tdTotalGasto}>{this.props.fondo.fondos_rendir? this.props.fondo.fondos_rendir.toLocaleString("es-CL", {style: "currency", currency: "clp"}) : 0}</td>
                {/* Diferencia */}
                <td className={css.tdDiferencia}>{this.props.fondo.total_gastos? this.props.fondo.total_gastos.toLocaleString("es-CL", {style: "currency", currency: "clp"}) : 0}</td>
                {/* Total Girado */}
                <td className={css.tdDiferencia}>{this.props.fondo.diferencia? this.props.fondo.diferencia.toLocaleString("es-CL", {style: "currency", currency: "clp"}) : 0}</td>
                {/* Acciones */}
                <td className={css.tdAcciones}>
                    <a className={'btn btn-sm btn-success'}
                       href={`/api/fondo/${this.props.fondo.idFondoPublica}/boucher-download`}>
                        <span className={'glyphicon glyphicon-link'}></span>
                    </a>
                </td>
                <td className={css.tdAcciones}>
                    <a className="btn btn-sm btn-info"
                        href={`/fondo/${this.props.fondo.idRendicion}`}
                        target="_blank">
                        <span className="glyphicon glyphicon-eye-open"/>
                    </a>
                </td>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/operarios/fondos-asignados/fondos/RowFondosAsignados.jsx